import { formatters } from '@utils/formattersV2';
import { SummaryCard } from '../SummaryCard';
import { VisitCharts } from './VisitCharts';
import { Lci3Report } from '@components/Dashboard/dashboardSlice/schemas/lci3Reports';
import { VisitHighlights } from '../../../Highlights';
import { Campaign } from '@features/campaigns/subdomains/visitation/api';
import { CpvHeroMetric } from './CpvHeroMetric';
import { AIInsightsCard } from '@components/shared/AIInsightsCard';
import { useLciAIInsights } from '@features/ai-insights';

type VisitSummaryProps = {
  campaign: Pick<Campaign, 'adSpend' | 'id' | 'name' | 'startDate' | 'endDate'>;
  selectedReport: Lci3Report;
  allReports: Lci3Report[];
};

export const VisitSummary = (props: VisitSummaryProps) => {
  const latestReportWithFootInsights = props.allReports.findLast(
    report => report.footTrafficAIInsights.length
  );

  const { footTrafficAiInsights } = useLciAIInsights(
    latestReportWithFootInsights ?? null,
    'summary'
  );

  return (
    <SummaryCard
      campaignId={props.campaign.id}
      label="Visit Summary"
      color="visit"
      metrics={[
        {
          key: 'costPerVisit',
          render: () => (
            <CpvHeroMetric
              campaign={props.campaign}
              report={props.selectedReport}
              visitsField="projectedVisits"
              metricProps={{
                label: 'Cost per Visit',
                colorScheme: 'visit',
                valueFormatter: formatters.currency,
              }}
            />
          ),
        },
        {
          key: 'costPerIncrementalVisit',
          render: () => (
            <CpvHeroMetric
              campaign={props.campaign}
              report={props.selectedReport}
              visitsField="incrementalVisits"
              metricProps={{
                label: 'Cost per Incremental Visit',
                colorScheme: 'visit',
                valueFormatter: formatters.currency,
              }}
            />
          ),
        },
      ]}
      allReports={props.allReports}
    >
      <AIInsightsCard
        testId="lci-visit-summary-ai-insights"
        title="Summary"
        aiInsights={footTrafficAiInsights ?? undefined}
        highlights={
          <VisitHighlights
            campaignName={props.campaign.name}
            report={props.selectedReport}
          />
        }
      />

      <VisitCharts allReports={props.allReports} />
    </SummaryCard>
  );
};
